// extracted by mini-css-extract-plugin
export var deleteModal = "_gu-0";